import moment from "moment";
import { getFirmInitiativeById } from "services/firmInitiatives.service";

function makeAlignmentData({ functions, serviceAreas, subServiceAreas, subSubFunction }) {
    const result = [];

    functions.forEach(func => {
        const matchedServiceAreas = serviceAreas?.filter(sa => sa.functionCode === func.functionCode) || [];

        if (matchedServiceAreas.length === 0) {
            result.push({
                functionCode: func.functionCode,
                serviceAreaCode: null,
                subServiceAreaCode: null,
                subSubFunctionCode: null
            });
        } else {
          matchedServiceAreas?.forEach(sa => {
            const matchedSubServiceAreas = subServiceAreas?.filter(ssa => ssa.serviceAreaCode === sa.serviceAreaCode) || [];

            if (matchedSubServiceAreas.length === 0) {
              result.push({
                functionCode: func.functionCode,
                serviceAreaCode: sa.serviceAreaCode,
                subServiceAreaCode: null,
                subSubFunctionCode: null
              });
            } else {
              matchedSubServiceAreas?.forEach(ssa => {
                const matchedSubSubFunctions = subSubFunction?.filter(ssf => ssf.subServiceAreaCode === ssa.subServiceAreaCode) || [];

                if (matchedSubSubFunctions?.length === 0) {
                  result.push({
                    functionCode: func.functionCode,
                    serviceAreaCode: sa.serviceAreaCode,
                    subServiceAreaCode: ssa.subServiceAreaCode,
                    subSubFunctionCode: null
                  })
                } else {
                  matchedSubSubFunctions.forEach(ssf => {
                    result.push({
                      functionCode: func.functionCode,
                      serviceAreaCode: sa.serviceAreaCode,
                      subServiceAreaCode: ssa.subServiceAreaCode,
                      subSubFunctionCode: ssf.subSubFunctionCode,
                    });
                  }) || [];
                }
              }) || [];
            }
          }) || [];
        }
    });

    return result;
}


export const getCreateArg = ({ data }) => {
    const body = {
        title: data.initiativeTitle,
        openFirmwide: data?.openFirmwide?.value === 'no' ? false : true,
        location: data?.location?.map(loc => ({ id: loc.id, label: loc.label, optionId: loc.optionId })) || [],
        grade: data?.grade?.map(gra => ({ id: gra.value, label: gra.label, code: gra.code })) || [],
        skillSet: data?.skillSet?.map(sks => ({ id: sks.id, label: sks.label, optionId: sks.optionId })) || [],
        numberOfOpenings: data.numberOfOpenings,
        startDate: data.startDate,
        endDate: data.endDate,
        hoursPerDay: data.approxHoursPerDay,
        entities: data?.entity?.map(ent => ({ id: ent.id, label: ent.label, optionId: ent.optionId })) || [],
        description: data?.description || '',
        status: 'open',
        initiativeOwnerIds: data?.initiativeOwners.map(io => io.id) || [],
        alignments: data.openFirmwide?.value === 'yes' ? [] : makeAlignmentData({ functions: data.function, serviceAreas: data.serviceArea, subServiceAreas: data.subServiceArea, subSubFunction: data?.subSubFunction }),
        isGradeSelectAll: data?.isGradeSelectAll,
        dlEmail: data?.dlEmail ?? '',
        notify_initiative_project_owner: !!data?.notify_initiative_project_owner
    };
    return body;
}

export const getStructuredFirmInitativeList = ({ firmInitiatives = [] }) => {
    return firmInitiatives?.map(fi => ({
        id: fi.id,
        initiativeTitle: fi.title,
        initiativeId: fi.initiative_code,
        openFirmwide: fi.open_firmwide ? 'Yes' : 'No',
        functions: fi?.functions?.length ? fi.functions : [{name: 'All'}],
        serviceAreas: fi?.serviceAreas?.length ? fi.serviceAreas : [{name: 'All'}],
        subServiceAreas: fi?.subServiceAreas?.length ? fi.subServiceAreas : [{name: 'All'}],
        subSubFunctions: fi?.subSubFunctions?.length ? fi.subSubFunctions : [{name: 'All'}],
        startDate: moment(fi.start_date).utc().format('MM-DD-YYYY'),
        endDate: moment(fi.end_date).utc().format('MM-DD-YYYY'),
        hoursPerDay: fi.hours_per_day,
        locations: fi.location,
        grades: fi.grade,
        hasAllGrade: fi.has_all_grades,
        skillSets: fi.skill_set,
        interestedEmployees: fi.interested_employees,
        numberOfOpenings: fi.number_of_openings,
        entities: fi.entities,
        intiativeStatus: fi?.emp_initiative_status ?? null,
        empInitiativeId: fi?.emp_initiative_id ?? null,
        initiativeProjectOwner: fi.owners,
        description: fi.description,
        status: fi.status,
        dlEmail: fi.dl_email,
        withdrawnReason: fi?.withdrawn_reason || '-',
        additionalWithdrawnComment: fi?.withdrawn_additional_comment || '-', 
        initiatorAccess: fi.projectInitiatorAccess,
        createdBy: fi.created_by_name,
        updatedBy: fi.updated_by_name,
        createdOn: moment(fi.created_at).utc().format('MM-DD-YYYY'),
        updatedOn: moment(fi.updated_at).utc().format('MM-DD-YYYY'),
        updatedOnTime: moment(fi.updated_at).utc().format('HH:mm:ss A'),
        defaultValue: {
            id: fi.id,
            empInitiativeId: fi?.emp_initiative_id ?? null,
            intiativeStatus: fi?.emp_initiative_status ?? null,
            initiativeTitle: fi.title,
            openFirmwide: { value: fi.open_firmwide ? 'yes' : 'no', label: fi.open_firmwide ? 'Yes' : 'No' },
            startDate: fi.start_date,
            endDate: fi.end_date,
            description: fi.description,
            dlEmail: fi.dl_email,
            notify_initiative_project_owner: !!fi.notify_initiative_project_owner,
            initiativeOwners: fi?.owners?.map(ow => ({ id: ow.id, label: ow.name, value: ow.id, email: ow.email })) || [],
            approxHoursPerDay: fi.hours_per_day,
            function: fi?.functions?.map(fa => ({ id: fa.id, label: fa.name, value: fa.id, functionCode: fa.function_code, name: fa.name })) || [],
            serviceArea: fi?.serviceAreas?.map(sa => ({ id: sa.id, label: sa.name, value: sa.id, functionCode: sa.function_code, serviceAreaCode: sa.service_area_code })) || [],
            subServiceArea: fi?.subServiceAreas?.map(saa => ({ id: saa.id, label: saa.name, value: saa.id, functionCode: saa.function_code, serviceAreaCode: saa.service_area_code, subServiceAreaCode: saa.sub_service_area_code })) || [],
            subSubFunction: fi?.subSubFunctions?.map(ssf => ({ id: ssf.id, label: ssf.name, value: ssf.id, functionCode: ssf.function_code, serviceAreaCode: ssf.service_area_code, subServiceAreaCode: ssf.sub_service_area_code, subSubFunctionCode: ssf.sub_sub_function_code })) || [],
            numberOfOpenings: fi.number_of_openings,
            location: fi?.location?.map(loc => ({ id: loc.id, optionId: loc.optionId, value: loc.id, label: loc.label })) || [],
            designation: fi?.designation?.map(deg => ({ id: deg.id, optionId: deg.optionId, value: deg.id, label: deg.label })) || [],
            skillSet: fi?.skill_set?.map(ss => ({ id: ss.id, optionId: ss.optionId, value: ss.id, label: ss.label })) || [],
            entity: fi?.entities?.map(ent => ({ id: ent.id, optionId: ent.optionId, value: ent.id, label: ent.label })) || [],
            grade: fi?.grade?.map(gra => ({ id: gra.id, optionId: gra.optionId, value: gra.id, label: gra.label })) || [],
        }
    })) ?? []
}

export const getUpdateArg = ({ data }) => {
    const body = {
        title: data.initiativeTitle,
        openFirmwide: data?.openFirmwide?.value === 'no' ? false : true,
        location: data?.location?.map(loc => ({ id: loc.id, label: loc.label, optionId: loc.optionId })) || [],
        grade: data?.grade?.map(gra => ({ id: gra.value, label: gra.label, code: gra.code })) || [],
        skillSet: data?.skillSet?.map(sks => ({ id: sks.id, label: sks.label, optionId: sks.optionId })) || [],
        numberOfOpenings: data.numberOfOpenings,
        startDate: data.startDate,
        endDate: data.endDate,
        hoursPerDay: data.approxHoursPerDay,
        entities: data?.entity?.map(ent => ({ id: ent.id, label: ent.label, optionId: ent.optionId })) || [],
        description: data?.description || '',
        initiativeOwnerIds: data?.initiativeOwners.map(io => io.id) || [],
        alignments: data.openFirmwide?.value === 'yes' ? [] : makeAlignmentData({ functions: data.function, serviceAreas: data.serviceArea, subServiceAreas: data.subServiceArea, subSubFunction: data?.subSubFunction }),
        isGradeSelectAll: data?.isGradeSelectAll,
        notify_initiative_project_owner: !!data?.notify_initiative_project_owner,
        dlEmail: data?.dlEmail ?? ''
    };
    return body;
}

function extractAlignments(data) {
  const functions = [];
  const serviceAreas = [];
  const subServiceAreas = [];
  const subSubFunction = [];

  const functionIds = new Set();
  const serviceAreaIds = new Set();
  const subServiceAreaIds = new Set();
  const subSubFunctionIds = new Set();

  data.forEach(item => {
    if (item.functions && item.functions.id && !functionIds.has(item.functions.id)) {
      functions.push({
        label: item.functions.name,
        name: item.functions.name,
        id: item.functions.id,
        value: item.functions.id,
        functionCode: item.functions.functionCode
      });
      functionIds.add(item.functions.id);
    }
    if (item.serviceAreas && item.serviceAreas.id && !serviceAreaIds.has(item.serviceAreas.id)) {
      serviceAreas.push({
        label: item.serviceAreas.name,
        name: item.serviceAreas.name,
        id: item.serviceAreas.id,
        value: item.serviceAreas.id,
        functionCode: item.serviceAreas.functionCode,
        serviceAreaCode: item.serviceAreas.serviceAreaCode
      });
      serviceAreaIds.add(item.serviceAreas.id);
    }
    if (item.subServiceAreas && item.subServiceAreas.id && !subServiceAreaIds.has(item.subServiceAreas.id)) {
      subServiceAreas.push({
        label: item.subServiceAreas.name,
        name: item.subServiceAreas.name,
        id: item.subServiceAreas.id,
        value: item.subServiceAreas.id,
        functionCode: item.subServiceAreas.functionCode,
        serviceAreaCode: item.subServiceAreas.serviceAreaCode,
        subServiceAreaCode: item.subServiceAreas.subServiceAreaCode
      });
      subServiceAreaIds.add(item.subServiceAreas.id);
    }
    if(item.subSubFunctions && item.subSubFunctions.id && !subSubFunctionIds.has(item.subSubFunctions.id)) {
      subSubFunction.push({
        label: item.subSubFunctions.name,
        name: item.subSubFunctions.name,
        id: item.subSubFunctions.id,
        value: item.subSubFunctions.id,
        functionCode: item.subSubFunctions.functionCode,
        serviceAreaCode: item.subSubFunctions.serviceAreaCode,
        subServiceAreaCode: item.subSubFunctions.subServiceAreaCode,
        subSubFunctionCode: item.subSubFunctions.subSubFunctionCode
      });
      subSubFunctionIds.add(item.subSubFunctions.id);
    }
  });

  return { functions, serviceAreas, subServiceAreas, subSubFunction };
}

export const fetchInitiativeDetail = async (id) => {
  const response = await getFirmInitiativeById({ id })
  if (response.status) {
    const { functions, serviceAreas, subServiceAreas, subSubFunction } = extractAlignments(response.entity.firmInitiativeAlignments)
    return {
      details: {
        initiativeTitle: response?.entity?.title,
        initiativeId: response?.entity.initiativeCode,
        status: response?.entity?.status,
        noOfOpenings: response?.entity?.numberOfOpenings,
        hoursPerDay: response?.entity?.hoursPerDay,
        description: response?.entity?.description,
        startDate: moment(response?.entity?.startDate).format('MM/DD/YYYY'),
        endDate: moment(response?.entity?.endDate).format('MM/DD/YYYY'),
        location: response.entity.location.map(loc => loc.label),
        createdBy: response.entity.firmInitiativeCreatedBy?.name,
        createdOn: moment(response.entity.createdAt).format('MM/DD/YYYY'),
        initiatorAccess: response?.entity?.projectInitiatorAccess,
        multipleValueDetail: [
          {
            label: 'Initiative/Project Owner',
            value: response?.entity?.firmInitiativeOwners.map(io => io.owner.name)
          },
          {
            label: 'DL Email',
            value: response?.entity?.dlEmail
          },
          {
            label: 'Function',
            value: functions.length ? functions?.map((fun) => fun.label) : ['All']
          },
          {
            label: 'Service area',
            value: serviceAreas.length ? serviceAreas.map((ss) => ss.label) : ['All']
          },
          {
            label: 'Sub service area',
            value: subServiceAreas.length ? subServiceAreas.map((ssa) => ssa.label) : ['All']
          },
          {
            label: 'Sub sub function',
            value: subSubFunction.length ? subSubFunction.map((ssf) => ssf.label) : ['All']
          },
          {
            label: 'Entity',
            value: response.entity.entities.map((ent) => ent.label)
          },
          {
            label: 'Grade',
            value: response.entity.grade.map(gra => gra.label)
          },
          {
            label: 'Skill set',
            value: response.entity.skillSet.map(ss => ss.label)
          },
          {
            label: 'Notify Initiative/Project Owner',
            value: response?.entity?.notifyInitiativeProjectOwner ? ['Yes'] : ['No']
          }
        ]
      },
      defaultValue: {
        initiativeTitle: response?.entity?.title,
        openFirmwide: { value: response?.entity?.openFirmwide ? 'yes' : 'no', label: response?.entity?.openFirmwide ? 'Yes' : 'No' },
        startDate: response?.entity?.startDate,
        endDate: response?.entity?.endDate,
        description: response?.entity?.description,
        initiativeOwners: response?.entity?.firmInitiativeOwners?.map(ow => ({ id: ow.owner.id, label: ow.owner.name, value: ow.owner.id })) || [],
        approxHoursPerDay: response?.entity?.hoursPerDay,
        function: functions || [],
        dlEmail: response?.entity?.dlEmail,
        notify_initiative_project_owner: !!response?.entity?.notifyInitiativeProjectOwner,
        grade: response.entity.grade.map(gra => ({ id: gra.id, optionId: gra.optionId, value: gra.id, label: gra.label })),
        serviceArea: serviceAreas || [],
        subServiceArea: subServiceAreas || [],
        subSubFunction: subSubFunction || [],
        numberOfOpenings: response?.entity?.numberOfOpenings,
        location: response?.entity?.location?.map(loc => ({ id: loc.id, optionId: loc.optionId, value: loc.id, label: loc.label })) || [],
        designation: response?.entity?.designation?.map(deg => ({ id: deg.id, optionId: deg.optionId, value: deg.id, label: deg.label })) || [],
        skillSet: response?.entity?.skillSet?.map(ss => ({ id: ss.id, optionId: ss.optionId, value: ss.id, label: ss.label })) || [],
        entity: response?.entity?.entities?.map(ent => ({ id: ent.id, optionId: ent.optionId, value: ent.id, label: ent.label })) || [],
      },
      table: {
        rows: response?.entity?.initiativeEmployees?.map((emp) => ({
          id: emp?.employee?.id,
          initiativeStatus: emp?.status,
          employeeName: emp?.employee?.name,
          employeeCode: emp?.employee?.employeeCode,
          designation: emp?.employee?.designation,
          function: emp?.employee?.employeeFunction,
          serviceArea: emp?.employee?.serviceArea,
          subServiceArea: emp?.employee?.subServiceArea,
          subSubFunction: emp?.employee?.subSubFunctionDesc,
          location: emp?.employee?.location,
          reportingManager: emp?.employee?.reportingManagerDetail?.name,
          reportingPartner: emp?.employee?.reportingPartnerDetail?.name,
          updatedOn: moment(emp.updatedAt).utc().format('MM-DD-YYYY'),
          updatedOnTime: moment(emp.updatedAt).utc().format('HH:mm:ss A'),
        })) || []
      }
    };
  } else {
    return { details: {}, table: { rows: [] }, defaultValue: {} }
  }
}